"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newKpiWidget = exports.KpiWidgetBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var widgetFactory_1 = require("./widgetFactory");
var builder_1 = require("../builder");
/**
 * @alpha
 */
var KpiWidgetBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(KpiWidgetBuilder, _super);
    function KpiWidgetBuilder(item, validator) {
        var _this = _super.call(this, item, validator) || this;
        _this.item = item;
        _this.validator = validator;
        // TODO: un-nest legacy kpi
        _this.setKpiWidgetProp = function (prop, valueOrUpdateCallback) {
            _this.setWidget(function (w) {
                var _a;
                return (tslib_1.__assign(tslib_1.__assign({}, w), { kpi: tslib_1.__assign(tslib_1.__assign({}, w.kpi), (_a = {}, _a[prop] = builder_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, w.kpi[prop]), _a)) }));
            });
            return _this;
        };
        _this.drills = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("drills", valueOrUpdateCallback);
        };
        _this.measure = function (valueOrUpdateCallback) {
            return _this.setKpiWidgetProp("metric", valueOrUpdateCallback);
        };
        _this.comparisonType = function (valueOrUpdateCallback) { return _this.setKpiWidgetProp("comparisonType", valueOrUpdateCallback); };
        _this.comparisonDirection = function (valueOrUpdateCallback) { return _this.setKpiWidgetProp("comparisonDirection", valueOrUpdateCallback); };
        return _this;
    }
    KpiWidgetBuilder.for = function (kpiWidget) {
        ts_invariant_1.default(sdk_backend_spi_1.isKpiWidgetDefinition(kpiWidget) || sdk_backend_spi_1.isKpiWidget(kpiWidget), "Provided data must be IKpiWidget or IKpiWidgetDefinition!");
        return new KpiWidgetBuilder(kpiWidget);
    };
    KpiWidgetBuilder.forNew = function (measure) {
        var emptyKpiWidget = {
            description: "",
            drills: [],
            ignoreDashboardFilters: [],
            title: "",
            type: "kpi",
            kpi: {
                metric: measure,
                comparisonType: "none",
            },
        };
        return KpiWidgetBuilder.for(emptyKpiWidget);
    };
    return KpiWidgetBuilder;
}(widgetFactory_1.WidgetBaseBuilder));
exports.KpiWidgetBuilder = KpiWidgetBuilder;
/**
 * @alpha
 */
exports.newKpiWidget = function (measure, modifications) {
    return KpiWidgetBuilder.forNew(measure).modify(modifications).build();
};
//# sourceMappingURL=kpiWidgetFactory.js.map